import { i18n } from 'i18next';
import { catchError, concatMap, from, map, Observable, of, toArray } from 'rxjs';

import { HttpService, MomentService } from '@contact/upgrade';

import { IEpticaExctractEvent } from './models/eptica-extract';
import { EpticaSelector } from './models/eptica-selector';
import { EXTRACTERS, getExtracterOrElse } from './utils/eptica-extract-helper';

export interface IHistoryMailService {
  /**
   * Extract event from frame
   */
  extractEvents(
    requestId: number,
    baseUrl: string,
    local: string,
    frameId: string,
    selectors?: EpticaSelector[]
  ): Observable<IEpticaExctractEvent[]>;
}

export class HistoryMailService {
  static $inject: Array<string> = ['$i18next', 'momentService', 'http'];

  constructor(private readonly $i18next: i18n, private readonly momentService: MomentService, private readonly http: HttpService) {}

  public extractEvents(
    requestId: number,
    baseUrl: string,
    local: string,
    frameId: string,
    selectors?: EpticaSelector[]
  ): Observable<IEpticaExctractEvent[]> {
    let sw = {
      $i18next: this.$i18next,
      moment: this.momentService,
      requestId,
      baseUrl,
      local,
    };
    return from(selectors || Object.keys(EpticaSelector)).pipe(
      map(key => ({
        key,
        el: document.getElementById(frameId) as HTMLIFrameElement,
      })),
      // find eptica event in frame and extract them
      concatMap(
        // get dom elements
        ({ key, el }) =>
          Array.from(el.contentWindow!.document.querySelectorAll(`.historylist.row .content_history .${key}`))
            // extract data html element
            .map(node => getExtracterOrElse(key, EXTRACTERS)(sw, EpticaSelector[key], node))
      ),
      // get html content if necessary
      concatMap(evt =>
        !!evt.contentSrc
          ? this.http
              .get(this.normalizeUrl(baseUrl, evt.contentSrc), {
                headers: {
                  'Content-Type': 'text/plain; charset=UTF-8',
                  Accept: 'text/html',
                },
                responseType: 'text',
              })
              .pipe(
                map(contentHtml => ({
                  ...evt,
                  contentHtml,
                })),
                catchError(() => of(evt))
              )
          : of(evt)
      ),
      toArray()
    );
  }

  private normalizeUrl(base: string, target: string): string {
    const [first, second] = target.split('/');
    let to = base.lastIndexOf(first || second);
    to = to === -1 ? base.length : to - 1;
    base = base.substring(0, to);
    return `${base}${target}`;
  }
}

export default 'historyMailService';
